import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  placa: Yup.string()
    .min(2)
    .max(10)
    .required()
})
